/**
 * Created by bootdo.
 * 角色相关api
 */
import * as API from './'
import $const from '../common/constant'

export default {
  /**
   * 将根据 parentCode 查询出的 树 转换成  list （包含所有子节点） 和 map （key:code value:pathName）
   * @param params
   * @returns {Promise<*>}
   */
  getDictionaryTreeToMapAndList: params => {
     return API.GET($const.apiServer.Base + '/dictionary/getDictionaryTreeToMapAndList', params)
  },
  //根据parentCode 获取字典列表
  getListByParentCode: params => {
    return API.GET($const.apiServer.Base + '/dictionary/getListByParentCode', params)
  },
  getListByParentCodeNew: params => {
    return API.GET($const.apiServer.Tranning + '/web/tpush/mall/listJobType', params)
  },
  //根据parentCode 获取字典列表
  getListByParentCodeRewrite: params => {
    return API.GET($const.apiServer.Base + '/dictionary/getListByParentCodeRewrite', params)
  },
  getTrees: params => {
    return API.GET($const.apiServer.Base + '/dictionary/getTrees', params)
  },
  // query dictionary tree list (Support paging)
  pageList: params => {
    return API.GET($const.apiServer.Base + '/dictionary/pageList', params)
  },
  //批量修改和添加
  save: params => {
    return API.POST($const.apiServer.Base + '/dictionary/save', params)
  },
  //删除
  remove: params => {
    return API.GET($const.apiServer.Base + '/dictionary/remove', params)
  },
  //查询是否已存在该code
  getIsCode: params => {
    return API.GET($const.apiServer.Base + '/dictionary/getIsCode', params)
  },
  //根据id查询
  findById: params => {
    return API.GET($const.apiServer.Base + '/dictionary/getById', params)
  },
  getDictionaryResolveToTree: params => {
    return API.GET($const.apiServer.Base + '/dictionary/getDictionaryResolveToTree', params)
  },
}



// WEBPACK FOOTER //
// ./src/api/api_dictionary.js